/* eslint-disable react/jsx-no-duplicate-props */
/* eslint-disable no-unused-vars */
import React, { useState } from "react";
import Header from "../Header";
import Sidebar from "../Sidebar";
import { DatePicker, message } from "antd";
import FeatherIcon from "feather-icons-react/build/FeatherIcon";
import Select from "react-select";
import { Link, useNavigate } from 'react-router-dom';
import patientApi from "../../api/patient.api";

const AddPatientsBulgarian = () => {
  const navigate = useNavigate();
  
  // UI state
  const [loading, setLoading] = useState(false);
  
  // Patient form state
  const [formData, setFormData] = useState({
    egn: '',
    rzok: '',
    zdrRajon: '',
    fullName: {
      given: '',
      sur: '',
      family: ''
    },
    address: '',
    isHealthInsurance: false,
    dateOfBirth: '',
    gender: '',
    email: '',
    phone: '',
    medicalHistory: ''
  });

  // Bulgarian health region options (RZOK)
  const [rzokOptions] = useState([
    { value: "01", label: "01 - София-град" },
    { value: "02", label: "02 - Благоевград" },
    { value: "03", label: "03 - Бургас" },
    { value: "04", label: "04 - Велико Търново" },
    { value: "05", label: "05 - Видин" },
    { value: "06", label: "06 - Враца" },
    { value: "07", label: "07 - Габрово" },
    { value: "08", label: "08 - Добрич" },
    { value: "09", label: "09 - Кърджали" },
    { value: "10", label: "10 - Кюстендил" },
    { value: "11", label: "11 - Ловеч" },
    { value: "12", label: "12 - Монтана" },
    { value: "13", label: "13 - Пазарджик" },
    { value: "14", label: "14 - Перник" },
    { value: "15", label: "15 - Плевен" },
    { value: "16", label: "16 - Пловдив" },
    { value: "17", label: "17 - Разград" },
    { value: "18", label: "18 - Русе" },
    { value: "19", label: "19 - Силистра" },
    { value: "20", label: "20 - Сливен" },
    { value: "21", label: "21 - Смолян" },
    { value: "22", label: "22 - София-област" },
    { value: "23", label: "23 - Стара Загора" },
    { value: "24", label: "24 - Търговище" },
    { value: "25", label: "25 - Хасково" },
    { value: "26", label: "26 - Шумен" },
    { value: "27", label: "27 - Ямбол" },
    { value: "28", label: "28 - Варна" }
  ]);

  const [zdrRajonOptions] = useState([
    { value: "01", label: "01 - Първи здравен район" },
    { value: "02", label: "02 - Втори здравен район" },
    { value: "03", label: "03 - Трети здравен район" },
    { value: "04", label: "04 - Четвърти здравен район" },
    { value: "05", label: "05 - Пети здравен район" }
  ]);

  const onChange = (date, dateString) => {
    setFormData(prev => ({ ...prev, dateOfBirth: dateString }));
  };

  const handleInputChange = (field, value) => {
    if (field.includes('.')) {
      const [parent, child] = field.split('.');
      setFormData(prev => ({
        ...prev,
        [parent]: {
          ...prev[parent],
          [child]: value
        }
      }));
    } else {
      setFormData(prev => ({ ...prev, [field]: value }));
    }
  };

  const validateForm = () => {
    const required = ['egn', 'rzok', 'zdrRajon', 'address', 'dateOfBirth', 'gender'];
    const missing = required.filter(field => !formData[field]);
    
    // Check fullName fields
    if (!formData.fullName.given) missing.push('given name');
    if (!formData.fullName.sur) missing.push('sur name');
    if (!formData.fullName.family) missing.push('family name');
    
    if (missing.length > 0) {
      message.error(`Моля попълнете задължителните полета: ${missing.join(', ')}`);
      return false;
    }
    
    // EGN validation (should be exactly 10 digits)
    if (formData.egn.length !== 10 || !/^\d+$/.test(formData.egn)) {
      message.error('ЕГН трябва да бъде точно 10 цифри');
      return false;
    }
    
    // Email validation if provided
    if (formData.email) {
      const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
      if (!emailRegex.test(formData.email)) {
        message.error('Моля въведете валиден имейл адрес');
        return false;
      }
    }
    
    return true;
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    
    if (!validateForm()) {
      return;
    }
    
    setLoading(true);
    
    try {
      const patientData = {
        egn: formData.egn,
        rzok: formData.rzok,
        zdrRajon: formData.zdrRajon,
        givenName: formData.fullName.given,
        surName: formData.fullName.sur,
        familyName: formData.fullName.family,
        address: formData.address,
        isHealthInsurance: formData.isHealthInsurance,
        dateOfBirth: formData.dateOfBirth,
        gender: formData.gender === 'male' ? 'MALE' : 'FEMALE',
        email: formData.email || undefined,
        phone: formData.phone || undefined,
        medicalHistory: formData.medicalHistory || undefined
      };

      const createdPatient = await patientApi.createPatient(patientData);
      
      message.success(`Пациентът ${createdPatient.fullName} беше успешно създаден!`);
      
      // Reset form or navigate to patients list
      setTimeout(() => {
        navigate('/patients');
      }, 1500);
      
    } catch (error) {
      console.error('Error creating patient:', error);
      
      if (error.response?.status === 400) {
        message.error('Грешка при валидация на данните. Проверете полетата.');
      } else if (error.response?.data?.message) {
        message.error(error.response.data.message);
      } else {
        message.error('Грешка при създаване на пациента. Моля опитайте отново.');
      }
    } finally {
      setLoading(false);
    }
  };

  const loadFile = (event) => {
    // Handle file loading logic here
  };

  return (
    <div>
      <Header />
      <Sidebar
        id="menu-item2"
        id1="menu-items2"
        activeClassName="add-patient"
      />
      <>
        <div className="page-wrapper">
          <div className="content">
            {/* Page Header */}
            <div className="page-header">
              <div className="row">
                <div className="col-sm-12">
                  <ul className="breadcrumb">
                    <li className="breadcrumb-item">
                      <Link to="#">Пациенти </Link>
                    </li>
                    <li className="breadcrumb-item">
                      <i className="feather-chevron-right">
                        <FeatherIcon icon="chevron-right" />
                      </i>
                    </li>
                    <li className="breadcrumb-item active">Добави пациент</li>
                  </ul>
                </div>
              </div>
            </div>
            {/* /Page Header */}
            <div className="row">
              <div className="col-sm-12">
                <div className="card">
                  <div className="card-body">
                    <form onSubmit={handleSubmit}>
                      <div className="row">
                        <div className="col-12">
                          <div className="form-heading">
                            <h4>Данни за пациента</h4>
                          </div>
                        </div>
                        
                        {/* EGN */}
                        <div className="col-12 col-md-6 col-xl-4">
                          <div className="form-group local-forms">
                            <label>
                              ЕГН <span className="login-danger">*</span>
                            </label>
                            <input
                              className="form-control"
                              type="text"
                              placeholder="Въведете ЕГН"
                              value={formData.egn}
                              onChange={(e) => handleInputChange('egn', e.target.value)}
                              maxLength="10"
                              required
                            />
                          </div>
                        </div>

                        {/* Given Name */}
                        <div className="col-12 col-md-6 col-xl-4">
                          <div className="form-group local-forms">
                            <label>
                              Собствено име <span className="login-danger">*</span>
                            </label>
                            <input
                              className="form-control"
                              type="text"
                              placeholder="Въведете собствено име"
                              value={formData.fullName.given}
                              onChange={(e) => handleInputChange('fullName.given', e.target.value)}
                              required
                            />
                          </div>
                        </div>

                        {/* Sur Name (Father's name) */}
                        <div className="col-12 col-md-6 col-xl-4">
                          <div className="form-group local-forms">
                            <label>
                              Бащино име <span className="login-danger">*</span>
                            </label>
                            <input
                              className="form-control"
                              type="text"
                              placeholder="Въведете бащино име"
                              value={formData.fullName.sur}
                              onChange={(e) => handleInputChange('fullName.sur', e.target.value)}
                              required
                            />
                          </div>
                        </div>

                        {/* Family Name */}
                        <div className="col-12 col-md-6 col-xl-4">
                          <div className="form-group local-forms">
                            <label>
                              Фамилно име <span className="login-danger">*</span>
                            </label>
                            <input
                              className="form-control"
                              type="text"
                              placeholder="Въведете фамилно име"
                              value={formData.fullName.family}
                              onChange={(e) => handleInputChange('fullName.family', e.target.value)}
                              required
                            />
                          </div>
                        </div>

                        {/* RZOK */}
                        <div className="col-12 col-md-6 col-xl-4">
                          <div className="form-group local-forms">
                            <label>
                              РЗОК <span className="login-danger">*</span>
                            </label>
                            <Select
                              value={rzokOptions.find(opt => opt.value === formData.rzok)}
                              onChange={(selected) => handleInputChange('rzok', selected?.value || '')}
                              options={rzokOptions}
                              placeholder="Изберете РЗОК"
                              id="rzok-select"
                              classNamePrefix="react-select"
                              menuPortalTarget={document.body}
                              menuPosition="fixed"
                              components={{
                                IndicatorSeparator: () => null
                              }}
                              styles={{
                                control: (baseStyles, state) => ({
                                  ...baseStyles,
                                  borderColor: state.isFocused ?'none' : '2px solid rgba(46, 55, 164, 0.1);',
                                   boxShadow: state.isFocused ? '0 0 0 1px #2e37a4' : 'none',
                                  '&:hover': {
                                    borderColor: state.isFocused ? 'none' : '2px solid rgba(46, 55, 164, 0.1)',
                                  },
                                  borderRadius: '10px',
                                  fontSize: "14px",
                                    minHeight: "45px",
                                }),
                                menuPortal: (base) => ({ 
                                  ...base, 
                                  zIndex: 1050 
                                }),
                                menu: (base) => ({
                                  ...base,
                                  marginTop: 0
                                })
                              }}
                            />
                          </div>
                        </div>

                        {/* Health Region */}
                        <div className="col-12 col-md-6 col-xl-4">
                          <div className="form-group local-forms">
                            <label>
                              Здравен район <span className="login-danger">*</span>
                            </label>
                            <Select
                              value={zdrRajonOptions.find(opt => opt.value === formData.zdrRajon)}
                              onChange={(selected) => handleInputChange('zdrRajon', selected?.value || '')}
                              options={zdrRajonOptions}
                              placeholder="Изберете здравен район"
                              id="zdr-rajon-select"
                              components={{
                                IndicatorSeparator: () => null
                              }}
                              styles={{
                                control: (baseStyles, state) => ({
                                  ...baseStyles,
                                  borderColor: state.isFocused ?'none' : '2px solid rgba(46, 55, 164, 0.1);',
                                   boxShadow: state.isFocused ? '0 0 0 1px #2e37a4' : 'none',
                                  '&:hover': {
                                    borderColor: state.isFocused ? 'none' : '2px solid rgba(46, 55, 164, 0.1)',
                                  },
                                  borderRadius: '10px',
                                  fontSize: "14px",
                                    minHeight: "45px",
                                }),
                              }}
                            />
                          </div>
                        </div>

                        {/* Phone */}
                        <div className="col-12 col-md-6 col-xl-4">
                          <div className="form-group local-forms">
                            <label>
                              Мобилен телефон
                            </label>
                            <input
                              className="form-control"
                              type="text"
                              placeholder="Въведете телефон"
                              value={formData.phone}
                              onChange={(e) => handleInputChange('phone', e.target.value)}
                            />
                          </div>
                        </div>

                        {/* Email */}
                        <div className="col-12 col-md-6 col-xl-6">
                          <div className="form-group local-forms">
                            <label>
                              Имейл
                            </label>
                            <input
                              className="form-control"
                              type="email"
                              placeholder="Въведете имейл"
                              value={formData.email}
                              onChange={(e) => handleInputChange('email', e.target.value)}
                              autoComplete="email"
                            />
                          </div>
                        </div>

                        {/* Date of Birth */}
                        <div className="col-12 col-md-6 col-xl-6">
                          <div className="form-group local-forms cal-icon">
                            <label>
                              Дата на раждане{" "}
                              <span className="login-danger">*</span>
                            </label>
                            <DatePicker
                              className="form-control datetimepicker"
                              onChange={onChange}
                              suffixIcon={null}
                              placeholder="Изберете дата"
                            />
                          </div>
                        </div>

                        {/* Gender */}
                        <div className="col-12 col-md-6 col-xl-6">
                          <div className="form-group select-gender">
                            <label className="gen-label">
                              Пол<span className="login-danger">*</span>
                            </label>
                            <div className="form-check-inline">
                              <label className="form-check-label">
                                <input
                                  type="radio"
                                  name="gender"
                                  className="form-check-input"
                                  value="male"
                                  checked={formData.gender === 'male'}
                                  onChange={(e) => handleInputChange('gender', e.target.value)}
                                />
                                Мъж
                              </label>
                            </div>
                            <div className="form-check-inline">
                              <label className="form-check-label">
                                <input
                                  type="radio"
                                  name="gender"
                                  className="form-check-input"
                                  value="female"
                                  checked={formData.gender === 'female'}
                                  onChange={(e) => handleInputChange('gender', e.target.value)}
                                />
                                Жена
                              </label>
                            </div>
                          </div>
                        </div>

                        {/* Health Insurance */}
                        <div className="col-12 col-md-6 col-xl-6">
                          <div className="form-group select-gender">
                            <label className="gen-label">
                              Здравно осигуряване <span className="login-danger">*</span>
                            </label>
                            <div className="form-check-inline">
                              <label className="form-check-label">
                                <input
                                  type="radio"
                                  name="insurance"
                                  className="form-check-input"
                                  value="true"
                                  checked={formData.isHealthInsurance === true}
                                  onChange={(e) => handleInputChange('isHealthInsurance', true)}
                                />
                                Осигурен
                              </label>
                            </div>
                            <div className="form-check-inline">
                              <label className="form-check-label">
                                <input
                                  type="radio"
                                  name="insurance"
                                  className="form-check-input"
                                  value="false"
                                  checked={formData.isHealthInsurance === false}
                                  onChange={(e) => handleInputChange('isHealthInsurance', false)}
                                />
                                Неосигурен
                              </label>
                            </div>
                          </div>
                        </div>

                        {/* Address */}
                        <div className="col-12 col-sm-12">
                          <div className="form-group local-forms">
                            <label>
                              Адрес <span className="login-danger">*</span>
                            </label>
                            <textarea
                              className="form-control"
                              rows={3}
                              cols={30}
                              placeholder="Въведете адрес"
                              value={formData.address}
                              onChange={(e) => handleInputChange('address', e.target.value)}
                              required
                            />
                          </div>
                        </div>

                        {/* Medical History */}
                        <div className="col-12 col-sm-12">
                          <div className="form-group local-forms">
                            <label>
                              Медицинска история
                            </label>
                            <textarea
                              className="form-control"
                              rows={3}
                              cols={30}
                              placeholder="Въведете медицинска история"
                              value={formData.medicalHistory}
                              onChange={(e) => handleInputChange('medicalHistory', e.target.value)}
                            />
                          </div>
                        </div>

                        {/* Submit Buttons */}
                        <div className="col-12">
                          <div className="doctor-submit d-flex align-items-center flex-column flex-sm-row justify-content-end">
                            <Link
                              to="/patients"
                              className="btn btn-primary cancel-form d-flex align-items-center justify-content-center mb-2 mb-sm-0 me-sm-2"
                              style={{ 
                                height: '45px', 
                                textAlign: 'center', 
                                textDecoration: 'none',
                                paddingLeft: '15px',
                                paddingRight: '15px',
                                width: '100%',
                                maxWidth: '150px'
                              }}
                            >
                              Отказ
                            </Link>
                            <button
                              type="submit"
                              className="btn btn-primary submit-form"
                              disabled={loading}
                              style={{ 
                                height: '45px',
                                width: '100%',
                                maxWidth: '200px'
                              }}
                            >
                              {loading ? 'Записва...' : 'Запази пациент'}
                            </button>
                          </div>
                        </div>
                      </div>
                    </form>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </>
      <style jsx>{`
        .cal-icon::after {
          top: 60% !important;
          transform: translateY(-50%) !important;
        }
      `}</style>
    </div>
  );
};

export default AddPatientsBulgarian;